import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { api } from "../lib/api";

const MOTIVES = [
  { code: "01", label: "Comprobante emitido con errores con relación", hint: "Requiere el UUID de la factura que sustituye a ésta." },
  { code: "02", label: "Comprobante emitido con errores sin relación", hint: "No se emitirá factura de reemplazo." },
  { code: "03", label: "No se llevó a cabo la operación", hint: "La venta u operación no ocurrió." },
  { code: "04", label: "Operación nominativa relacionada en una factura global", hint: "Aplica sólo al régimen público general." },
];

export default function CancelInvoiceModal({ invoice, onClose, onCancelled }) {
  const [motive, setMotive] = useState("02");
  const [substitutionUuid, setSubstitutionUuid] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { setError(""); }, [motive]);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const payload = { motive, reason };
      if (motive === "01") payload.substitution_uuid = substitutionUuid.trim();
      const response = await api.post(`/invoices/sent/${invoice.id}/cancel`, payload, { withCredentials: true });
      onCancelled(response.data);
    } catch (issue) {
      setError(issue.response?.data?.detail || "No pudimos cancelar la factura.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cash-modal-backdrop" onClick={onClose} data-testid="cancel-invoice-modal">
      <div className="cash-modal" onClick={(e) => e.stopPropagation()} style={{ width: "min(560px, 96vw)" }}>
        <header>
          <div>
            <small>CANCELAR CFDI</small>
            <b>Folio {invoice.folio}</b>
          </div>
          <button type="button" onClick={onClose} data-testid="cancel-invoice-close" aria-label="Cerrar"><X size={18} /></button>
        </header>
        <form onSubmit={submit}>
          <div style={{ padding: "0 24px 16px" }}>
            <div className="cancel-invoice-warn" data-testid="cancel-invoice-warn">
              <AlertTriangle size={16} />
              <span>Cancelar una factura ante el SAT es <b>irreversible</b>. Elige el motivo correcto: el receptor debe autorizarlo si tiene efectos fiscales.</span>
            </div>

            <fieldset className="cash-status-picker" data-testid="cancel-invoice-motives" style={{ marginTop: 12 }}>
              <legend>Motivo SAT</legend>
              {MOTIVES.map((m) => (
                <label key={m.code} className={motive === m.code ? "active" : ""} data-testid={`cancel-motive-${m.code}-label`}>
                  <input type="radio" name="motive" value={m.code} checked={motive === m.code} onChange={() => setMotive(m.code)} data-testid={`cancel-motive-${m.code}`} />
                  <div>
                    <b>{m.code} · {m.label}</b>
                    <small>{m.hint}</small>
                  </div>
                </label>
              ))}
            </fieldset>

            {motive === "01" && (
              <label style={{ display: "block", marginTop: 12 }}>
                UUID de la factura que sustituye
                <input
                  type="text"
                  value={substitutionUuid}
                  onChange={(e) => setSubstitutionUuid(e.target.value)}
                  placeholder="ABCD-1234-EFGH-5678-..."
                  required
                  data-testid="cancel-substitution-uuid"
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb", marginTop: 6, fontFamily: "monospace" }}
                />
              </label>
            )}

            <label style={{ display: "block", marginTop: 12 }}>
              Nota interna (opcional)
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={2}
                placeholder="Ej: Datos del cliente incorrectos, se sustituye por factura B..."
                data-testid="cancel-invoice-reason"
                style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb", marginTop: 6, resize: "vertical" }}
              />
            </label>

            {error && <p className="profile-error" data-testid="cancel-invoice-error" style={{ marginTop: 10 }}>{error}</p>}
          </div>

          <div className="cash-modal-actions">
            <button type="button" onClick={onClose} className="cash-btn ghost" data-testid="cancel-invoice-abort">Volver</button>
            <button type="submit" className="cash-btn danger" disabled={busy} data-testid="cancel-invoice-confirm">
              {busy ? "Cancelando..." : "Cancelar CFDI"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
